import { Row, Col } from 'antd';

import { CustomNotification, FormButton } from 'common/components';

import { DollarCircleOutlined } from '@ant-design/icons';

import {
  RequiredActiveProductModal,
  RequiredActiveProductRoot,
  RequiredActiveProductSection,
} from '../RequiredActiveProduct';

import { useRequiredActiveProductModal } from '../hooks';
import { useCheckCreditCardPermission } from 'hooks/useCheckCreditCardPermission';
import { useCheckPaymentTermMonthAndMemberStatusCreditReview } from 'hooks/member/useCheckPaymentTermMonthAndMemberStatusCreditReview';
import { useGetProductImagesByStatus } from 'hooks/useGetProductImagesByStatus';
import { useGlobalModal } from 'hooks';

import {
  filterInvalidValuesFormValues,
  getDifferentFields,
} from 'common/components/product-add/make-product-active/utils';

import {
  getAutoPopulateFields,
  getAutoPopulateSource,
} from 'common/components/product-add/components/utils/barcode';

import { sleep } from 'utils/delay';

export const ChargeActiveProduct = (props) => {
  const {
    entityId,
    productData,
    entityType,
    productForm,
    validateProducts = [],
    onRevalidateProduct,
    productImagery,
    getFormPayload,
  } = props;

  const { canPayViaCreditCard: hasPermissionActiveProduct } =
    useCheckCreditCardPermission();
  const isPaymentTermMonthAndMemberStatusCreditReview =
    useCheckPaymentTermMonthAndMemberStatusCreditReview();

  const {
    visibleModalRequiredActiveProduct,
    onModalRequiredActiveProduct,
    offModalRequiredActiveProduct,
  } = useRequiredActiveProductModal();

  const { invalidateProductImagesByStatus } = useGetProductImagesByStatus({
    status: productData?.status,
    productId: entityId,
    options: {
      enabled: false,
    },
  });

  const { closeModal, MODAL_NAMES } = useGlobalModal();

  return (
    <>
      <Row>
        <Col
          xl={{
            offset: 0,
            span: 24,
          }}
          xxl={{
            offset: 8,
          }}
        >
          <FormButton
            text='Active Product'
            onClick={async () => {
              const formValues = getFormPayload();
              const { gtin, upc8, upc12, upc13 } = productData ?? {};
              const currentValues = { gtin, upc13, upc12, upc8 };
              const source = getAutoPopulateSource(currentValues);
              const autoPopulatedFields = source
                ? getAutoPopulateFields(
                    source.type,
                    source.value,
                    currentValues
                  )
                : {};
              const mappingProductData = {
                ...productData,
                id: productData?.productId,
                category1Id: productData?.category1?.categoryId,
                category2Id: productData?.category2?.categoryId,
                category3Id: productData?.category3?.categoryId,
                category4Id: productData?.category4?.categoryId,
                brick: productData?.brickCode || null,
                countryOfOrigin: productData?.countryOfOrigin || [],
                ...autoPopulatedFields,
              };

              const differentFields = getDifferentFields(
                filterInvalidValuesFormValues(formValues),
                filterInvalidValuesFormValues(mappingProductData)
              );

              const isChangedFieldValue =
                Object.keys(differentFields)?.length > 0;

              if (isChangedFieldValue) {
                CustomNotification.warning(
                  'You have unsaved field changes. Please save before activating the product.'
                );
                return;
              }
              onModalRequiredActiveProduct();
              await sleep();
              onRevalidateProduct && (await onRevalidateProduct()); // on edit product with a current form values, user toggle "Active Product"
            }}
            icon={<DollarCircleOutlined style={{ fontSize: 14 }} />}
            disabled={
              !hasPermissionActiveProduct ||
              isPaymentTermMonthAndMemberStatusCreditReview
            }
          />
        </Col>
      </Row>
      {visibleModalRequiredActiveProduct && (
        <RequiredActiveProductRoot>
          <RequiredActiveProductModal
            visible={visibleModalRequiredActiveProduct}
            onCancel={offModalRequiredActiveProduct}
            entityId={entityId}
            entityType={entityType}
            onRevalidateProduct={onRevalidateProduct}
            productForm={productForm}
            validateProducts={validateProducts}
            onMakeActiveSuccessCallback={() => {
              closeModal(MODAL_NAMES.ADD_EDIT_PRODUCT_MODAL);
            }}
            onUpdateUnmatchedSuccessCallback={() => {
              invalidateProductImagesByStatus();
            }}
          >
            <RequiredActiveProductSection
              entityId={entityId}
              entityType={entityType}
              productForm={productForm}
              validateProducts={validateProducts}
              productImagery={productImagery}
              onRevalidateProduct={onRevalidateProduct}
            />
          </RequiredActiveProductModal>
        </RequiredActiveProductRoot>
      )}
    </>
  );
};
